export const STORE_RESET = 'RESET';

export const DATA = {
    UPDATE: 'DATA_UPDATE',
    LOADING: 'DATA_LOADING',
    FILTER: 'DATA_FILTER',
    SETTING: 'DATA_SETTING'
};